module.exports = __webpack_public_path__ + "static/the-art-of-memoir-585fd94858548188ffefd8b032be077a.jpg";